var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineSmartHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "200A6414-A6F3-45A0-BF65-383598B47C77") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Essetional",
    transform: "translate(-748.000000, -700.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "smart-home",
    transform: "translate(748.000000, 700.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3998299,22.5598946 C10.9898299,22.5598946 10.6498299,22.2198946 10.6498299,21.8098946 C10.6498299,21.3998946 10.9898299,21.0598946 11.3998299,21.0598946 L17.5998421,21.0598946 C18.6698421,21.0598946 19.7198299,20.1698213 19.8998299,19.1098213 L21.229847,11.1498613 C21.349847,10.4298613 20.9498506,9.39978808 20.3898506,8.94978809 L13.4598274,3.40987098 C12.6598274,2.769871 11.3298445,2.76986122 10.5398445,3.39986122 L3.60982108,8.94978809 C3.03982109,9.4097881 2.64982475,10.4298613 2.76982474,11.1498613 L3.04982352,12.8398027 C3.11982352,13.2498027 2.8398284,13.6397881 2.42982841,13.6997881 C2.01982841,13.7797881 1.63984311,13.489793 1.56984311,13.079793 L1.28984433,11.3998613 C1.07984433,10.1598613 1.67984915,8.56986624 2.66984916,7.77986622 L9.59984207,2.22981721 C10.9398421,1.14981717 13.0498298,1.15982693 14.3998299,2.23982698 L21.3298225,7.77986622 C22.3098226,8.56986624 22.9098274,10.1598613 22.7098274,11.3998613 L21.3798409,19.3598213 C21.0798408,21.1298213 19.389842,22.5598946 17.5998421,22.5598946 L11.3998299,22.5598946 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.25022149,22.0200195 C4.22022149,20.6700195 3.33023244,19.78 1.98023242,19.75 C1.57023242,19.74 1.24022142,19.3999805 1.25022142,18.9799805 C1.26022141,18.5699805 1.59022143,18.25 2.00022143,18.25 C2.01022143,18.25 2.01021045,18.25 2.02021044,18.25 C4.17021054,18.3 5.71022125,19.8299804 5.75022125,21.9799805 C5.76022125,22.3899805 5.4302105,22.74 5.0202105,22.75 C5.0102105,22.75 5.01022149,22.75 5.00022149,22.75 C4.59022149,22.75 4.26022149,22.4200195 4.25022149,22.0200195 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25021505,22.0100098 C7.24021505,21.3500097 7.13020773,20.7200049 6.93020773,20.1300049 C6.42020774,18.6700048 5.33021021,17.5899463 3.87021017,17.0699463 C3.2802102,16.8599463 2.65020537,16.75 1.99020535,16.75 C1.58020535,16.75 1.24021512,16.4099902 1.25021512,15.9899902 C1.25021512,15.5799902 1.59021512,15.25 2.00021511,15.25 L2.01022488,15.25 C2.84022486,15.26 3.63021016,15.4000342 4.37021017,15.6600342 C6.26021016,16.3300342 7.67021137,17.7400049 8.34021139,19.6300049 C8.60021138,20.3700049 8.74021505,21.1699902 8.75021505,21.9899902 C8.75021505,22.4099902 8.42021504,22.75 8.00021505,22.75 C8.00688172,22.75 8.00688172,22.75 8.00021505,22.75 C7.59021506,22.75 7.25021505,22.4200098 7.25021505,22.0100098 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,22 C1,21.45 1.44999999,21 2,21 C2.55000001,21 3,21.45 3,22 C3,22.55 2.56,23 2,23 C1.44,23 1,22.55 1,22 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,0 L24,24 L0,24 L0,0 L24,0 Z",
    id: "Vector",
    opacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineSmartHome);
export default __webpack_public_path__ + "static/media/vuesax-outline-smart-home.85073994f9199a7778f5f515a0163bab.svg";
export { ForwardRef as ReactComponent };